import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* =====================================================
   VERIFY PAYMENT & PLACE ORDER
===================================================== */
export const verifyPayment = createAsyncThunk(
  "checkout/verifyPayment",
  async (
    {
      razorpay_order_id,
      razorpay_payment_id,
      razorpay_signature,
      shippingAddress,
    },
    thunkAPI
  ) => {
    try {
      // Get token from Redux state
      const state = thunkAPI.getState();
      const token = state.auth.token || localStorage.getItem("token");

      if (!token) {
        return thunkAPI.rejectWithValue("No authentication token found");
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/checkout/verify-payment`,
        {
          razorpay_order_id,
          razorpay_payment_id,
          razorpay_signature,
          shippingAddress,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Payment verification failed"
      );
    }
  }
);

/* =====================================================
   SLICE
===================================================== */
const checkoutSlice = createSlice({
  name: "checkout",
  initialState: {
    loading: false,
    success: false,
    error: null,
    orderId: null,
  },
  reducers: {
    resetCheckout: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.orderId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.orderId = action.payload.orderId;
      })
      .addCase(verifyPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetCheckout } = checkoutSlice.actions;
export default checkoutSlice.reducer;